export default "__VITE_ASSET__BDOqwKDu__"